// Legal entity name sourced from src/config/countries/<code>.json via
// the per-country loader. Selection is driven by REACT_APP_PORTAL_COUNTRY
// at build time.

import country from 'config/countryConfig';

export const LEGAL_ENTITY_NAME: string = country.legalEntityName;
